import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

export const routes = [
  {
    path: '/404',
    name: 'not-found',
    component: () => import('@/views/404')
  },
  {
    path: '/:key',
    name: 'survey',
    component: () => import('@/views/survey')
  },
  {
    path: '/preview/m/:key',
    name: 'survey',
    component: () => import('@/views/survey'),
    isMPreview: true
  },
  {
    path: '/preview/c/:key',
    name: 'survey',
    component: () => import('@/views/survey'),
    isCPreview: true
  },
];

export default new VueRouter({
  scrollBehavior: () => ({
    y: 0
  }),
  mode: 'history', //hash
  routes: routes
});

